import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionService } from 'src/app/services/session.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-change-email',
  templateUrl: './change-email.component.html',
  styleUrls: ['./change-email.component.scss']
})
export class ChangeEmailComponent implements OnInit {
  isLoading = true;
  isSubmitted = false;
  email: string;
  errMsg: string = null;

  constructor(private sessionSvc: SessionService, private userSvc: UserService, private router: Router, private route: ActivatedRoute) { }

  ngOnInit(): void {

    this.sessionSvc.getToken().subscribe(token => {
      this.email = token.email;
      this.isLoading = false;
    })
  }

  save(form: NgForm) {
    this.errMsg = null;
    if(form.invalid) {
      this.isSubmitted = true;
      return;
    }


    this.isLoading = true;
    this.userSvc.putUser({ email: this.email }).subscribe({
      next: res => {

        //reload session
        this.sessionSvc.getSession(true).subscribe({
          next: newSess => {
            this.isLoading = false;
            this.router.navigate(['../'], { relativeTo: this.route });
          },
          error: err => {
            this.isLoading = false;
          }
        })

      },
      error: err => {
        this.isLoading = false;
        console.log(err.error.message);
        this.errMsg = err.error.message;
      }
    })
  }

}
